import { render, staticRenderFns } from "./Tours.vue?vue&type=template&id=0cae8f5a"
import script from "./Tours.vue?vue&type=script&lang=js"
export * from "./Tours.vue?vue&type=script&lang=js"
import style0 from "./Tours.vue?vue&type=style&index=0&id=0cae8f5a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports